/**
 * *****************************************************
 * ╔╦╗╔═╗  ╔╗╔╔═╗╔╦╗  ╔╦╗╔═╗╔╦╗╦╔═╗╦ ╦  ╔═╗╔╦╗╔═╗╔╦╗╔═╗┬
 *  ║║║ ║  ║║║║ ║ ║   ║║║║ ║ ║║║╠╣ ╚╦╝  ╚═╗ ║ ╠═╣ ║ ║╣ │
 * ═╩╝╚═╝  ╝╚╝╚═╝ ╩   ╩ ╩╚═╝═╩╝╩╚   ╩   ╚═╝ ╩ ╩ ╩ ╩ ╚═╝o
 * ALWAYS RETURN A COPY
 * *****************************************************
 */

import { ZIPCODE } from '../actions/constants';

/**
 * [offers description]
 * @param  {[type]} state  =             [] [description]
 * @param  {[type]} action [description]
 * @return {[type]}        [description]
 */
export default function zipcode(state = '', action) {
  switch (action.type) {
    case ZIPCODE.UPDATE: {
      return action.data.zipcode;
    }
    default:
      return state;
  }
}
